export const LEFT_HAND_VICTORY = [
  {
    t: [-0.0485, -0.0629, -0.0748],
    r: [0.5235, 0.0269, -0.0122, 0.8515],
    s: [1, 1, 1],
  },
  {
    t: [-0.0274, -0.0424, -0.0935],
    r: [0.2683, -0.0091, -0.2476, 0.9309],
    s: [1, 1, 1],
  },
  {
    t: [-0.0197, -0.0171, -0.1372],
    r: [-0.0874, 0.2587, -0.5403, 0.7959],
    s: [1, 1, 1],
  },
  {
    t: [-0.0337, -0.0134, -0.1604],
    r: [-0.1021, 0.3471, -0.5231, 0.7717],
    s: [1, 1, 1],
  },
  {
    t: [-0.0538, -0.0084, -0.1819],
    r: [-0.1021, 0.3471, -0.5231, 0.7717],
    s: [1, 1, 1],
  },
  {
    t: [-0.0376, -0.037, -0.0897],
    r: [0.5048, -0.107, 0.0348, 0.8559],
    s: [1, 1, 1],
  },
  {
    t: [-0.0266, 0.0281, -0.1246],
    r: [0.567, -0.0696, 0.0098, 0.8207],
    s: [1, 1, 1],
  },
  {
    t: [-0.0224, 0.0646, -0.1371],
    r: [0.5031, -0.0677, 0.0059, 0.8615],
    s: [1, 1, 1],
  },
  {
    t: [-0.0201, 0.0836, -0.1477],
    r: [0.4589, -0.0365, 0.0223, 0.8874],
    s: [1, 1, 1],
  },
  {
    t: [-0.019, 0.1018, -0.1617],
    r: [0.4589, -0.0365, 0.0223, 0.8874],
    s: [1, 1, 1],
  },
  {
    t: [-0.0503, -0.0361, -0.0891],
    r: [0.5225, -0.0136, 0.0382, 0.8517],
    s: [1, 1, 1],
  },
  {
    t: [-0.0515, 0.0267, -0.1211],
    r: [0.5428, 0.1035, 0.1149, 0.8255],
    s: [1, 1, 1],
  },
  {
    t: [-0.0638, 0.0631, -0.1369],
    r: [0.5306, 0.067, 0.0906, 0.8401],
    s: [1, 1, 1],
  },
  {
    t: [-0.0702, 0.0896, -0.1495],
    r: [0.5467, 0.0608, 0.081, 0.8312],
    s: [1, 1, 1],
  },
  {
    t: [-0.0747, 0.1108, -0.1601],
    r: [0.5467, 0.0608, 0.081, 0.8312],
    s: [1, 1, 1],
  },
  {
    t: [-0.0613, -0.0396, -0.0891],
    r: [0.4925, 0.0763, 0.0204, 0.8667],
    s: [1, 1, 1],
  },
  {
    t: [-0.0712, 0.0158, -0.1219],
    r: [0.2546, -0.0246, 0.1592, 0.9535],
    s: [1, 1, 1],
  },
  {
    t: [-0.0722, 0.0349, -0.1561],
    r: [-0.2354, -0.1181, 0.1042, 0.959],
    s: [1, 1, 1],
  },
  {
    t: [-0.0638, 0.0217, -0.1832],
    r: [-0.4573, -0.1496, 0.0503, 0.8752],
    s: [1, 1, 1],
  },
  {
    t: [-0.0571, 0.0041, -0.1941],
    r: [-0.4573, -0.1496, 0.0503, 0.8752],
    s: [1, 1, 1],
  },
  {
    t: [-0.0706, -0.045, -0.0892],
    r: [0.4433, 0.1733, 0.0233, 0.8791],
    s: [1, 1, 1],
  },
  {
    t: [-0.0898, 0.0006, -0.1216],
    r: [0.0458, -0.1976, 0.107, 0.9733],
    s: [1, 1, 1],
  },
  {
    t: [-0.0762, 0.0038, -0.1526],
    r: [-0.348, -0.2273, 0.0117, 0.9095],
    s: [1, 1, 1],
  },
  {
    t: [-0.0668, -0.0095, -0.1675],
    r: [-0.5475, -0.2656, -0.0806, 0.7894],
    s: [1, 1, 1],
  },
  {
    t: [-0.0618, -0.0269, -0.1725],
    r: [-0.5475, -0.2656, -0.0806, 0.7894],
    s: [1, 1, 1],
  },
] as const;

export const RIGHT_HAND_VICTORY = [
  {
    t: [-0.0017, -0.0652, -0.0663],
    r: [0.5651, 0.0392, -0.0573, 0.8221],
    s: [1, 1, 1],
  },
  {
    t: [-0.0247, -0.042, -0.0786],
    r: [0.3207, 0.0849, 0.243, 0.9115],
    s: [1, 1, 1],
  },
  {
    t: [-0.0407, -0.0141, -0.1186],
    r: [-0.0285, -0.1953, 0.5625, 0.8029],
    s: [1, 1, 1],
  },
  {
    t: [-0.031, -0.0094, -0.1439],
    r: [-0.0751, -0.3079, 0.5331, 0.7845],
    s: [1, 1, 1],
  },
  {
    t: [-0.0133, -0.0043, -0.1673],
    r: [-0.0751, -0.3079, 0.5331, 0.7845],
    s: [1, 1, 1],
  },
  {
    t: [-0.0136, -0.0376, -0.076],
    r: [0.5464, 0.1682, -0.0848, 0.8161],
    s: [1, 1, 1],
  },
  {
    t: [-0.0272, 0.0313, -0.1019],
    r: [0.6129, 0.1411, -0.0752, 0.7738],
    s: [1, 1, 1],
  },
  {
    t: [-0.032, 0.0692, -0.1089],
    r: [0.5643, 0.143, -0.0679, 0.8103],
    s: [1, 1, 1],
  },
  {
    t: [-0.0353, 0.0897, -0.1161],
    r: [0.5256, 0.1162, -0.0834, 0.8386],
    s: [1, 1, 1],
  },
  {
    t: [-0.038, 0.11, -0.1265],
    r: [0.5256, 0.1162, -0.0834, 0.8386],
    s: [1, 1, 1],
  },
  {
    t: [-0.0009, -0.0372, -0.0776],
    r: [0.5593, 0.0765, -0.0968, 0.8197],
    s: [1, 1, 1],
  },
  {
    t: [-0.0021, 0.0287, -0.1033],
    r: [0.6072, -0.0412, -0.1868, 0.7712],
    s: [1, 1, 1],
  },
  {
    t: [0.01, 0.0671, -0.1136],
    r: [0.5687, 0.0002, -0.1587, 0.8071],
    s: [1, 1, 1],
  },
  {
    t: [0.0156, 0.0946, -0.124],
    r: [0.5609, 0.0092, -0.1498, 0.8142],
    s: [1, 1, 1],
  },
  {
    t: [0.019, 0.1163, -0.1339],
    r: [0.5609, 0.0092, -0.1498, 0.8142],
    s: [1, 1, 1],
  },
  {
    t: [0.0096, -0.0411, -0.08],
    r: [0.5291, -0.0092, -0.0837, 0.8443],
    s: [1, 1, 1],
  },
  {
    t: [0.0165, 0.0173, -0.1087],
    r: [0.2191, 0.1389, -0.1874, 0.9474],
    s: [1, 1, 1],
  },
  {
    t: [0.009, 0.0353, -0.1427],
    r: [-0.3548, 0.2386, -0.0503, 0.9026],
    s: [1, 1, 1],
  },
  {
    t: [-0.0055, 0.0162, -0.1628],
    r: [-0.5898, 0.2546, 0.0402, 0.7653],
    s: [1, 1, 1],
  },
  {
    t: [-0.0126, -0.0042, -0.1657],
    r: [-0.5898, 0.2546, 0.0402, 0.7653],
    s: [1, 1, 1],
  },
  {
    t: [0.0184, -0.0469, -0.0826],
    r: [0.4806, -0.0996, -0.0936, 0.8662],
    s: [1, 1, 1],
  },
  {
    t: [0.034, 0.0014, -0.1134],
    r: [0.079, 0.2891, -0.1225, 0.9461],
    s: [1, 1, 1],
  },
  {
    t: [0.0152, 0.0077, -0.141],
    r: [-0.2784, 0.3171, 0.0012, 0.9066],
    s: [1, 1, 1],
  },
  {
    t: [0.0023, -0.0029, -0.1556],
    r: [-0.458, 0.3482, 0.1094, 0.8106],
    s: [1, 1, 1],
  },
  {
    t: [-0.0053, -0.0187, -0.1623],
    r: [-0.458, 0.3482, 0.1094, 0.8106],
    s: [1, 1, 1],
  },
] as const;
